// Accounts Chart Mutations

export const updateAccountsChartsList = (state, payload) => {
  state.accountsChartsList = payload
}

export const setFullAccountsChartsList = (state, payload) => {
  state.fullAccountsChartsList = payload
}

export const setAccountsChartInfo = (state, payload) => {
  state.accountsChartInfo = payload
}
